<div class="icon-span-wrapper">
    <div class="icon-text-container" [ngClass]="{'text-color-overlay-s': overlay}">
        <div *ngIf="icon" class="leplace-icon icon-color-primary padding-right-xs">
            <icon-wrapper [icon]="icon"></icon-wrapper>
        </div>
        <span class="info-text-m bold">{{text}}
        </span>
    </div>
</div>